module.exports = __webpack_public_path__ + "img/zoll-ak-logo.e6b899d3.png";